export default __webpack_public_path__ + "static/media/DerekChen.1e0707ca.png";